import Vue from "vue";
import moment from "moment";
import "moment/locale/tr";

let userLanguage = localStorage.getItem("language") || "en";
moment.updateLocale(userLanguage, {
  week: {
    dow: 1
  }
});
Vue.prototype.$moment = moment;

export default moment;
